export default __webpack_public_path__ + "static/media/ListNotificationIcon.fb67ca13.svg";